<i18n>
{
	"en": {
		"label": "Associate with orders",
		"placeholder": "Choose orders"
	},
	"no": {
		"label": "Koble til oppdrag",
		"placeholder": "Velg oppdrag"
	}
}
</i18n>

<template>
	<t-multiselect
		ref="input"
		:label="$t('label')"
		:allItems="orders"
		:selectedItems="selectedItems"
		:placeholder="$t('placeholder')"
		:itemKeys="['orderNumber', 'customer.name']"
		v-bind="$attrs"
		v-on="$listeners"
		@updateFilters="getOrdersByStringFilter"
	/>
</template>

<script>
import { mapState, mapActions } from './store/orders.store.js';

export default {
	name: 'OrdersMultiselect',
	props: {
		selectedItems: Array,
		errors: Array,
	},

	computed: {
		...mapState(['orders']),
	},

	methods: {
		...mapActions(['getOrdersByStringFilter']),
	}
};
</script>
